import { takeLatest, put, call } from 'redux-saga/effects';
import { getMyNFTsActions } from './slice';
import { getMyNFTs, resellNFT } from './functions';

function* getMyNFTsReference({ payload }) {
  try {
    const response = yield call(getMyNFTs, payload);
    yield put(getMyNFTsActions.getMyNFTsSuccess(response));
  } catch (error) {
    yield put(getMyNFTsActions.getMyNFTsError(error));
  }
}
//
function* resellMyNFTsReference({ payload }) {
  try {
    const response = yield call(resellNFT, payload);
    yield put(getMyNFTsActions.resellMyNFTsSuccess(response));
  } catch (error) {
    yield put(getMyNFTsActions.resellMyNFTsError(error));
  }
}
//
function* GetMyNFTsSaga() {
  yield takeLatest(getMyNFTsActions.getMyNFTs.type, getMyNFTsReference);
  yield takeLatest(getMyNFTsActions.resellMyNFTs.type, resellMyNFTsReference);
}
//
export default GetMyNFTsSaga;
